// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════
   LiveTracking.css  –  Real-time ride tracking page styles
   ════════════════════════════════════════════════════════════════════ */

/* ── Reset + tokens ───────────────────────────────────────────────── */
.lt-root,
.lt-root * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

:root {
  --lt-bg:         #0f172a;
  --lt-surface:    #1e293b;
  --lt-surface2:   #263348;
  --lt-border:     rgba(255,255,255,0.07);
  --lt-text:       #f1f5f9;
  --lt-muted:      #94a3b8;
  --lt-accent:     #6366f1;
  --lt-accent2:    #818cf8;
  --lt-green:      #10b981;
  --lt-red:        #ef4444;
  --lt-amber:      #f59e0b;
  --lt-header-h:   58px;
  --lt-panel-w:    340px;
  --lt-radius:     14px;
  --lt-shadow:     0 8px 32px rgba(0,0,0,0.45);
}

/* ── Root layout ─────────────────────────────────────────────────── */
.lt-root {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  background: var(--lt-bg);
  color: var(--lt-text);
  overflow: hidden;
}

/* ── Header ───────────────────────────────────────────────────────── */
.lt-header {
  height: var(--lt-header-h);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: linear-gradient(135deg, #1e1b4b 0%, #1e293b 100%);
  border-bottom: 1px solid var(--lt-border);
  flex-shrink: 0;
  z-index: 100;
  gap: 12px;
}

.lt-header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.lt-brand-icon {
  font-size: 24px;
  filter: drop-shadow(0 0 8px rgba(99,102,241,0.7));
}

.lt-brand-name {
  font-size: 17px;
  font-weight: 700;
  background: linear-gradient(135deg, #a5b4fc, #818cf8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.3px;
}

.lt-header-ride-id {
  font-size: 13px;
  color: var(--lt-muted);
}

.lt-header-ride-id strong {
  color: var(--lt-accent2);
}

/* ── Socket status badge ────────────────────────────────────────── */
.lt-socket-badge {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 5px 13px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
  transition: all 0.4s;
}

.lt-socket-live {
  background: rgba(16,185,129,0.15);
  color: var(--lt-green);
  border: 1px solid rgba(16,185,129,0.35);
}

.lt-socket-connecting,
.lt-socket-disconnected {
  background: rgba(245,158,11,0.15);
  color: var(--lt-amber);
  border: 1px solid rgba(245,158,11,0.35);
}

.lt-pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  animation: lt-pulse 1.5s ease-in-out infinite;
}

@keyframes lt-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.4; transform: scale(0.75); }
}

/* ── Body (map + panel) ───────────────────────────────────────────── */
.lt-body {
  flex: 1 1;
  display: flex;
  overflow: hidden;
}

/* ── Map ──────────────────────────────────────────────────────────── */
.lt-map-wrap {
  flex: 1 1;
  position: relative;
  overflow: hidden;
}

.lt-map {
  width: 100%;
  height: 100%;
}

/* Floating overlays on the map */
.lt-map-overlay {
  position: absolute;
  top: 14px;
  left: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
}

.lt-status-pill {
  display: inline-block;
  padding: 5px 14px;
  border-radius: 99px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.4);
  text-shadow: 0 1px 3px rgba(0,0,0,0.4);
}

.lt-update-pill {
  background: rgba(15,23,42,0.82);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid var(--lt-border);
  border-radius: 99px;
  padding: 4px 12px;
  font-size: 11px;
  color: var(--lt-muted);
  box-shadow: 0 2px 12px rgba(0,0,0,0.3);
}

/* ── Side panel ────────────────────────────────────────────────────── */
.lt-panel {
  width: var(--lt-panel-w);
  flex-shrink: 0;
  background: var(--lt-surface);
  border-left: 1px solid var(--lt-border);
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.1) transparent;
  padding: 14px;
  gap: 12px;
}

.lt-panel::-webkit-scrollbar { width: 4px; }
.lt-panel::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 4px; }

/* ── Cards ─────────────────────────────────────────────────────────── */
.lt-card {
  background: var(--lt-surface2);
  border: 1px solid var(--lt-border);
  border-radius: var(--lt-radius);
  padding: 16px;
  transition: box-shadow 0.2s;
}

.lt-card:hover {
  box-shadow: 0 0 0 1px rgba(99,102,241,0.25);
}

.lt-card-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--lt-accent2);
  margin-bottom: 12px;
}

/* ── Route card ─────────────────────────────────────────────────────── */
.lt-route-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid var(--lt-border);
}

.lt-route-row:last-child { border-bottom: none; }

.lt-route-icon {
  margin-top: 2px;
  flex-shrink: 0;
}

.lt-route-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--lt-muted);
  margin-bottom: 2px;
}

.lt-route-addr {
  font-size: 13px;
  color: var(--lt-text);
  line-height: 1.4;
}

/* ── Coords card ─────────────────────────────────────────────────────── */
.lt-coords-card {
  background: linear-gradient(135deg, rgba(99,102,241,0.12), rgba(99,102,241,0.04));
  border-color: rgba(99,102,241,0.3);
  animation: lt-new-data 0.4s ease;
}

@keyframes lt-new-data {
  0%   { transform: translateY(-4px); opacity: 0.5; }
  100% { transform: translateY(0);    opacity: 1; }
}

.lt-coords-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.lt-coord-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.lt-coord-label {
  font-size: 10px;
  color: var(--lt-muted);
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.lt-coord-value {
  font-size: 14px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--lt-accent2);
}

/* ── Driver card ─────────────────────────────────────────────────────── */
.lt-driver-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.lt-driver-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--lt-border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  overflow: hidden;
  flex-shrink: 0;
  border: 2px solid rgba(99,102,241,0.4);
}

.lt-driver-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lt-driver-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--lt-text);
  margin-bottom: 4px;
}

.lt-driver-vehicle {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: var(--lt-muted);
  margin-bottom: 6px;
}

.lt-driver-call {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: var(--lt-green);
  text-decoration: none;
  background: rgba(16,185,129,0.1);
  border: 1px solid rgba(16,185,129,0.3);
  padding: 3px 10px;
  border-radius: 99px;
  font-weight: 500;
  transition: background 0.2s;
}

.lt-driver-call:hover {
  background: rgba(16,185,129,0.2);
}

/* ── Cab card ─────────────────────────────────────────────────────── */
.lt-cab-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.lt-cab-img {
  width: 70px;
  height: 42px;
  object-fit: contain;
  border-radius: 6px;
  background: rgba(255,255,255,0.05);
}

.lt-cab-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--lt-text);
  margin-bottom: 4px;
}

.lt-cab-meta {
  display: flex;
  gap: 10px;
  font-size: 12px;
  color: var(--lt-muted);
}

/* ── Share card ─────────────────────────────────────────────────────── */
.lt-share-url {
  font-size: 11px;
  color: var(--lt-muted);
  background: rgba(0,0,0,0.25);
  border: 1px solid var(--lt-border);
  border-radius: 8px;
  padding: 8px 10px;
  word-break: break-all;
  margin-bottom: 10px;
  line-height: 1.5;
}

.lt-copy-btn {
  width: 100%;
  padding: 9px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, var(--lt-accent), #4f46e5);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.15s;
}

.lt-copy-btn:hover  { opacity: 0.9; transform: translateY(-1px); }
.lt-copy-btn:active { transform: translateY(0); }

/* ── Loader ───────────────────────────────────────────────────────── */
.lt-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100dvh;
  background: var(--lt-bg);
  gap: 16px;
}

.lt-loader-car {
  font-size: 56px;
  animation: lt-bounce-car 1.2s ease-in-out infinite;
}

@keyframes lt-bounce-car {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-12px); }
}

.lt-loader-text {
  font-size: 15px;
  color: var(--lt-muted);
  letter-spacing: 0.3px;
}

.lt-loader-bar {
  width: 200px;
  height: 3px;
  background: rgba(255,255,255,0.08);
  border-radius: 99px;
  overflow: hidden;
}

.lt-loader-bar-inner {
  height: 100%;
  width: 40%;
  background: linear-gradient(90deg, var(--lt-accent), var(--lt-accent2));
  border-radius: 99px;
  animation: lt-slide 1.4s ease-in-out infinite;
}

@keyframes lt-slide {
  0%   { transform: translateX(-150%); }
  100% { transform: translateX(350%); }
}

/* ── Error page ───────────────────────────────────────────────────── */
.lt-error-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  background: var(--lt-bg);
  padding: 24px;
}

.lt-error-card {
  background: var(--lt-surface);
  border: 1px solid var(--lt-border);
  border-radius: 20px;
  padding: 40px 32px;
  text-align: center;
  max-width: 400px;
  width: 100%;
  box-shadow: var(--lt-shadow);
}

.lt-error-icon { font-size: 52px; margin-bottom: 16px; }

.lt-error-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--lt-text);
  margin-bottom: 8px;
}

.lt-error-msg {
  font-size: 14px;
  color: var(--lt-muted);
  margin-bottom: 6px;
}

.lt-error-sub {
  font-size: 12px;
  color: var(--lt-muted);
  margin-bottom: 24px;
}

.lt-error-btn {
  display: inline-block;
  padding: 10px 28px;
  border-radius: 99px;
  background: linear-gradient(135deg, var(--lt-accent), #4f46e5);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.2s, transform 0.15s;
}

.lt-error-btn:hover { opacity: 0.9; transform: translateY(-2px); }

/* ── Responsive ───────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .lt-body {
    flex-direction: column;
  }

  .lt-panel {
    width: 100%;
    max-height: 52vh;
    border-left: none;
    border-top: 1px solid var(--lt-border);
    padding: 12px;
    gap: 10px;
  }

  .lt-map-wrap {
    flex: 1 1;
    min-height: 48vh;
  }

  .lt-header {
    padding: 0 14px;
  }

  .lt-brand-name { font-size: 15px; }
  .lt-header-ride-id { display: none; }
}

@media (max-width: 400px) {
  .lt-socket-badge { padding: 4px 10px; font-size: 11px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTracking.css"],"names":[],"mappings":"AAAA;;yEAEyE;;AAIzE,wEAAwE;AACxE;;EAEE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,0DAA0D;AAC5D;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,uCAAuC;EACvC,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,6DAA6D;EAC7D,yCAAyC;EACzC,cAAc;EACd,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;;EAEE,iCAAiC;EACjC,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,YAAY,YAAY,EAAE,sBAAsB,EAAE;AACpD;;AAEA,wEAAwE;AACxE;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA,yEAAyE;AACzE;EACE,wBAAwB;EACxB,cAAc;EACd,6BAA6B;EAC7B,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB;EAChB,qBAAqB;EACrB,kDAAkD;EAClD,aAAa;EACb,SAAS;AACX;;AAEA,+BAA+B,UAAU,EAAE;AAC3C,qCAAqC,iCAAiC,EAAE,kBAAkB,EAAE;;AAE5F,yEAAyE;AACzE;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,yCAAyC;AAC3C;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,iFAAiF;EACjF,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,OAAO,2BAA2B,EAAE,YAAY,EAAE;EAClD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;EAChC,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA,0EAA0E;AAC1E;EACE,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,8DAA8D;EAC9D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA,sBAAsB,YAAY,EAAE,2BAA2B,EAAE;AACjE,sBAAsB,wBAAwB,EAAE;;AAEhD,wEAAwE;AACxE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,YAAY,4BAA4B,EAAE;AAC5C;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uEAAuE;EACvE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;AAC9B;;AAEA,iBAAiB,eAAe,EAAE,mBAAmB,EAAE;;AAEvD;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,8DAA8D;EAC9D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,sBAAsB,YAAY,EAAE,2BAA2B,EAAE;;AAEjE,wEAAwE;AACxE;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,sCAAsC;IACtC,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA,iBAAiB,eAAe,EAAE;EAClC,qBAAqB,aAAa,EAAE;AACtC;;AAEA;EACE,mBAAmB,iBAAiB,EAAE,eAAe,EAAE;AACzD","sourcesContent":["/* ════════════════════════════════════════════════════════════════════\n   LiveTracking.css  –  Real-time ride tracking page styles\n   ════════════════════════════════════════════════════════════════════ */\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* ── Reset + tokens ───────────────────────────────────────────────── */\n.lt-root,\n.lt-root * {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n}\n\n:root {\n  --lt-bg:         #0f172a;\n  --lt-surface:    #1e293b;\n  --lt-surface2:   #263348;\n  --lt-border:     rgba(255,255,255,0.07);\n  --lt-text:       #f1f5f9;\n  --lt-muted:      #94a3b8;\n  --lt-accent:     #6366f1;\n  --lt-accent2:    #818cf8;\n  --lt-green:      #10b981;\n  --lt-red:        #ef4444;\n  --lt-amber:      #f59e0b;\n  --lt-header-h:   58px;\n  --lt-panel-w:    340px;\n  --lt-radius:     14px;\n  --lt-shadow:     0 8px 32px rgba(0,0,0,0.45);\n}\n\n/* ── Root layout ─────────────────────────────────────────────────── */\n.lt-root {\n  display: flex;\n  flex-direction: column;\n  height: 100dvh;\n  background: var(--lt-bg);\n  color: var(--lt-text);\n  overflow: hidden;\n}\n\n/* ── Header ───────────────────────────────────────────────────────── */\n.lt-header {\n  height: var(--lt-header-h);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  background: linear-gradient(135deg, #1e1b4b 0%, #1e293b 100%);\n  border-bottom: 1px solid var(--lt-border);\n  flex-shrink: 0;\n  z-index: 100;\n  gap: 12px;\n}\n\n.lt-header-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.lt-brand-icon {\n  font-size: 24px;\n  filter: drop-shadow(0 0 8px rgba(99,102,241,0.7));\n}\n\n.lt-brand-name {\n  font-size: 17px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #a5b4fc, #818cf8);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.3px;\n}\n\n.lt-header-ride-id {\n  font-size: 13px;\n  color: var(--lt-muted);\n}\n\n.lt-header-ride-id strong {\n  color: var(--lt-accent2);\n}\n\n/* ── Socket status badge ────────────────────────────────────────── */\n.lt-socket-badge {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 5px 13px;\n  border-radius: 99px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  transition: all 0.4s;\n}\n\n.lt-socket-live {\n  background: rgba(16,185,129,0.15);\n  color: var(--lt-green);\n  border: 1px solid rgba(16,185,129,0.35);\n}\n\n.lt-socket-connecting,\n.lt-socket-disconnected {\n  background: rgba(245,158,11,0.15);\n  color: var(--lt-amber);\n  border: 1px solid rgba(245,158,11,0.35);\n}\n\n.lt-pulse-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  animation: lt-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes lt-pulse {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50%       { opacity: 0.4; transform: scale(0.75); }\n}\n\n/* ── Body (map + panel) ───────────────────────────────────────────── */\n.lt-body {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n/* ── Map ──────────────────────────────────────────────────────────── */\n.lt-map-wrap {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n}\n\n.lt-map {\n  width: 100%;\n  height: 100%;\n}\n\n/* Floating overlays on the map */\n.lt-map-overlay {\n  position: absolute;\n  top: 14px;\n  left: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  pointer-events: none;\n}\n\n.lt-status-pill {\n  display: inline-block;\n  padding: 5px 14px;\n  border-radius: 99px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: 1px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.4);\n  text-shadow: 0 1px 3px rgba(0,0,0,0.4);\n}\n\n.lt-update-pill {\n  background: rgba(15,23,42,0.82);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid var(--lt-border);\n  border-radius: 99px;\n  padding: 4px 12px;\n  font-size: 11px;\n  color: var(--lt-muted);\n  box-shadow: 0 2px 12px rgba(0,0,0,0.3);\n}\n\n/* ── Side panel ────────────────────────────────────────────────────── */\n.lt-panel {\n  width: var(--lt-panel-w);\n  flex-shrink: 0;\n  background: var(--lt-surface);\n  border-left: 1px solid var(--lt-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255,255,255,0.1) transparent;\n  padding: 14px;\n  gap: 12px;\n}\n\n.lt-panel::-webkit-scrollbar { width: 4px; }\n.lt-panel::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 4px; }\n\n/* ── Cards ─────────────────────────────────────────────────────────── */\n.lt-card {\n  background: var(--lt-surface2);\n  border: 1px solid var(--lt-border);\n  border-radius: var(--lt-radius);\n  padding: 16px;\n  transition: box-shadow 0.2s;\n}\n\n.lt-card:hover {\n  box-shadow: 0 0 0 1px rgba(99,102,241,0.25);\n}\n\n.lt-card-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--lt-accent2);\n  margin-bottom: 12px;\n}\n\n/* ── Route card ─────────────────────────────────────────────────────── */\n.lt-route-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--lt-border);\n}\n\n.lt-route-row:last-child { border-bottom: none; }\n\n.lt-route-icon {\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.lt-route-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: var(--lt-muted);\n  margin-bottom: 2px;\n}\n\n.lt-route-addr {\n  font-size: 13px;\n  color: var(--lt-text);\n  line-height: 1.4;\n}\n\n/* ── Coords card ─────────────────────────────────────────────────────── */\n.lt-coords-card {\n  background: linear-gradient(135deg, rgba(99,102,241,0.12), rgba(99,102,241,0.04));\n  border-color: rgba(99,102,241,0.3);\n  animation: lt-new-data 0.4s ease;\n}\n\n@keyframes lt-new-data {\n  0%   { transform: translateY(-4px); opacity: 0.5; }\n  100% { transform: translateY(0);    opacity: 1; }\n}\n\n.lt-coords-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.lt-coord-item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.lt-coord-label {\n  font-size: 10px;\n  color: var(--lt-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n}\n\n.lt-coord-value {\n  font-size: 14px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: var(--lt-accent2);\n}\n\n/* ── Driver card ─────────────────────────────────────────────────────── */\n.lt-driver-info {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.lt-driver-avatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: var(--lt-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  overflow: hidden;\n  flex-shrink: 0;\n  border: 2px solid rgba(99,102,241,0.4);\n}\n\n.lt-driver-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.lt-driver-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--lt-text);\n  margin-bottom: 4px;\n}\n\n.lt-driver-vehicle {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  color: var(--lt-muted);\n  margin-bottom: 6px;\n}\n\n.lt-driver-call {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  color: var(--lt-green);\n  text-decoration: none;\n  background: rgba(16,185,129,0.1);\n  border: 1px solid rgba(16,185,129,0.3);\n  padding: 3px 10px;\n  border-radius: 99px;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.lt-driver-call:hover {\n  background: rgba(16,185,129,0.2);\n}\n\n/* ── Cab card ─────────────────────────────────────────────────────── */\n.lt-cab-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.lt-cab-img {\n  width: 70px;\n  height: 42px;\n  object-fit: contain;\n  border-radius: 6px;\n  background: rgba(255,255,255,0.05);\n}\n\n.lt-cab-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--lt-text);\n  margin-bottom: 4px;\n}\n\n.lt-cab-meta {\n  display: flex;\n  gap: 10px;\n  font-size: 12px;\n  color: var(--lt-muted);\n}\n\n/* ── Share card ─────────────────────────────────────────────────────── */\n.lt-share-url {\n  font-size: 11px;\n  color: var(--lt-muted);\n  background: rgba(0,0,0,0.25);\n  border: 1px solid var(--lt-border);\n  border-radius: 8px;\n  padding: 8px 10px;\n  word-break: break-all;\n  margin-bottom: 10px;\n  line-height: 1.5;\n}\n\n.lt-copy-btn {\n  width: 100%;\n  padding: 9px;\n  border: none;\n  border-radius: 8px;\n  background: linear-gradient(135deg, var(--lt-accent), #4f46e5);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.15s;\n}\n\n.lt-copy-btn:hover  { opacity: 0.9; transform: translateY(-1px); }\n.lt-copy-btn:active { transform: translateY(0); }\n\n/* ── Loader ───────────────────────────────────────────────────────── */\n.lt-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100dvh;\n  background: var(--lt-bg);\n  gap: 16px;\n}\n\n.lt-loader-car {\n  font-size: 56px;\n  animation: lt-bounce-car 1.2s ease-in-out infinite;\n}\n\n@keyframes lt-bounce-car {\n  0%, 100% { transform: translateY(0); }\n  50%       { transform: translateY(-12px); }\n}\n\n.lt-loader-text {\n  font-size: 15px;\n  color: var(--lt-muted);\n  letter-spacing: 0.3px;\n}\n\n.lt-loader-bar {\n  width: 200px;\n  height: 3px;\n  background: rgba(255,255,255,0.08);\n  border-radius: 99px;\n  overflow: hidden;\n}\n\n.lt-loader-bar-inner {\n  height: 100%;\n  width: 40%;\n  background: linear-gradient(90deg, var(--lt-accent), var(--lt-accent2));\n  border-radius: 99px;\n  animation: lt-slide 1.4s ease-in-out infinite;\n}\n\n@keyframes lt-slide {\n  0%   { transform: translateX(-150%); }\n  100% { transform: translateX(350%); }\n}\n\n/* ── Error page ───────────────────────────────────────────────────── */\n.lt-error-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100dvh;\n  background: var(--lt-bg);\n  padding: 24px;\n}\n\n.lt-error-card {\n  background: var(--lt-surface);\n  border: 1px solid var(--lt-border);\n  border-radius: 20px;\n  padding: 40px 32px;\n  text-align: center;\n  max-width: 400px;\n  width: 100%;\n  box-shadow: var(--lt-shadow);\n}\n\n.lt-error-icon { font-size: 52px; margin-bottom: 16px; }\n\n.lt-error-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--lt-text);\n  margin-bottom: 8px;\n}\n\n.lt-error-msg {\n  font-size: 14px;\n  color: var(--lt-muted);\n  margin-bottom: 6px;\n}\n\n.lt-error-sub {\n  font-size: 12px;\n  color: var(--lt-muted);\n  margin-bottom: 24px;\n}\n\n.lt-error-btn {\n  display: inline-block;\n  padding: 10px 28px;\n  border-radius: 99px;\n  background: linear-gradient(135deg, var(--lt-accent), #4f46e5);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: opacity 0.2s, transform 0.15s;\n}\n\n.lt-error-btn:hover { opacity: 0.9; transform: translateY(-2px); }\n\n/* ── Responsive ───────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .lt-body {\n    flex-direction: column;\n  }\n\n  .lt-panel {\n    width: 100%;\n    max-height: 52vh;\n    border-left: none;\n    border-top: 1px solid var(--lt-border);\n    padding: 12px;\n    gap: 10px;\n  }\n\n  .lt-map-wrap {\n    flex: 1;\n    min-height: 48vh;\n  }\n\n  .lt-header {\n    padding: 0 14px;\n  }\n\n  .lt-brand-name { font-size: 15px; }\n  .lt-header-ride-id { display: none; }\n}\n\n@media (max-width: 400px) {\n  .lt-socket-badge { padding: 4px 10px; font-size: 11px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
